export default [
  {
    title: 'exchange-ecosystembanner-cryptoAssetExchange',
    description: 'exchange-ecosystem-bring',
    list: [
      {
        icon: 'exchange',
        name: 'Exchange',
        des: 'exchange-header-assetExchange',
        bgImg: 'exchange.png',
        url: 'trade/BTC_USDT',
        listsDataId: 'listsData-a-ecosystemExchange',
      },
    ],
  },
  {
    title: 'exchange-ecosystembanner-investmentFundraising',
    description: 'exchange-ecosystem-empower',
    list: [
      {
        icon: 'labs',
        name: 'Labs',
        des: 'exchange-header-labs',
        bgImg: 'labs.png',
        url: 'https://labs.binance.com/',
        listsDataId: 'listsData-a-ecosystemLabs',
      },
      {
        icon: 'launchpad',
        name: 'Launchpad',
        des: 'exchange-header-launchpad',
        bgImg: 'launchpad.png',
        url: 'https://launchpad.binance.com/',
        listsDataId: 'listsData-a-ecosystemLaunchpad',
      },
    ],
  },
  {
    title: 'exchange-ecosystembanner-digitalAssetResearch',
    description: 'exchange-ecosystem-provideProfessional',
    list: [
      {
        icon: 'info',
        name: 'Info',
        des: 'exchange-header-Info',
        bgImg: 'info.png',
        url: 'https://info.binance.com/',
        listsDataId: 'listsData-a-ecosystemInfo',
      },
      {
        icon: 'research',
        name: 'Research',
        des: 'exchange-header-research',
        bgImg: 'research.png',
        url: 'https://research.binance.com/',
        listsDataId: 'listsData-a-ecosystemResearch',
      },
      {
        icon: 'academy',
        name: 'Academy',
        des: 'exchange-header-education',
        bgImg: 'Academy.png',
        url: 'https://www.binance.vision/',
        listsDataId: 'listsData-a-ecosystemAcademy',
      },
    ],
  },
  {
    title: 'exchange-ecosystem-supportAdoption',
    description: 'exchange-ecosystem-promoteTransparentInitiatives',
    list: [
      {
        icon: 'bcf',
        name: 'Charity',
        des: 'exchange-header-BCF',
        bgImg: 'charity.png',
        url: 'https://www.binance.charity/',
        listsDataId: 'listsData-a-ecosystemCharity',
      },
      {
        icon: 'trust-wallet',
        name: 'Trust Wallet',
        des: 'exchange-header-trustWallet',
        bgImg: 'trust-wallet.png',
        url: 'https://trustwallet.com/',
        listsDataId: 'listsData-a-ecosystemTrustWallet',
      },
    ],
  },
];
